import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// Define the API service
export const hrApi = createApi({
  reducerPath: "hrApi",
  baseQuery: fetchBaseQuery({ baseUrl: "/api" }),
  endpoints: (builder) => ({
    registerHR: builder.mutation({
      query: (hrData) => ({
        url: "/hr/register",
        method: "POST",
        body: hrData,
      }),
      invalidatesTags: [{ type: "HR", id: "LIST" }],
    }),
    deleteHR: builder.mutation({
      query: (hrId) => ({
        url: `hr/${hrId}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "HR", id: "LIST" }],
    }),
    editHR: builder.mutation({
      query: ({ hrId, hrData }) => ({
        url: `hr/${hrId}`,
        method: "PUT",
        body: hrData,
      }),
      invalidatesTags: [{ type: "HR", id: "LIST" }],
    }),
    getHR: builder.query({
      query: () => `/hr`,
      providesTags: [{ type: "HR", id: "LIST" }],
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useRegisterHRMutation,
  useDeleteHRMutation,
  useEditHRMutation,
  useGetHRQuery,
} = hrApi;
